define('lib/Utils',['require','Config'],function (require) {

    var Config = require('Config');

    /**
     * Returns global Util object
     */
    return {

        formatPrice: function (priceVal, currency, fn) {
            var currencyStr = currency;
            var currenciesInfo = Config.getInstance().getOption('currency_info');
            var currencyInfo = null;

            if (currenciesInfo) {
                var currentCurrencyCode = String(currencyStr).toUpperCase();
                if (currenciesInfo[currentCurrencyCode]) {
                    currencyInfo = currenciesInfo[currentCurrencyCode];
                }
            }

            if (Locale.has('currency_' + currencyStr)) {
                currencyStr = Locale.get('currency_' + currencyStr);
            }

            // skip decimals in case price > 1000
            // #1871
            // var skipDecimalsAfterValue = 1000;
            // var skipDecimals = priceVal >= skipDecimalsAfterValue;

            // @todo must be refactored.

            var fixed = 2;
            var priceResult = {
                'currency_symbol': currency,
                'currency': currencyStr,
                'decimal_digits': 2,
                'decimal_separator': '.',
                'space_btw_amount_and_symbol': 0,
                'symbol_on_left': 1,
                'skip_decimals': false,
                'number': Math.floor(priceVal),
                'decimal': this.pad(Math.round((Number(priceVal).toFixed(2) - Math.floor(priceVal)) * Math.pow(10, 2)), 2)
            };

            if (currencyInfo && currencyInfo.name) {
                fixed = parseInt(currencyInfo.decimal_digits);
                priceResult = _.extend(priceResult, {
                    'currency_name': currencyInfo.name,
                    'currency_symbol': currencyInfo.symbol,
                    'decimal_separator': currencyInfo.decimal_separator,
                    'space_btw_amount_and_symbol': typeof currencyInfo.space_btw_amount_and_symbol === 'boolean'?currencyInfo.space_btw_amount_and_symbol:parseInt(currencyInfo.space_btw_amount_and_symbol),
                    'symbol_on_left': parseInt(currencyInfo.symbol_on_left) > 0,
                    'decimal_digits': fixed,
                    'skip_decimals': fixed <= 0,
                    'number': Math.floor(priceVal),
                    'decimal': this.pad(Math.round((Number(priceVal).toFixed(fixed) - Math.floor(priceVal)) * Math.pow(10, fixed)), fixed)
                });

                // if (skipDecimals) {
                //     priceResult = _.extend(priceResult, {
                //         'currency_name' : currencyInfo.name,
                //         'currency_symbol': currencyInfo.symbol,
                //         'decimal_separator': currencyInfo.decimal_separator,
                //         'space_btw_amount_and_symbol' : parseInt(currencyInfo.space_btw_amount_and_symbol),
                //         'symbol_on_left' : parseInt(currencyInfo.symbol_on_left)>0,
                //         'decimal_digits' : 0,
                //         'skip_decimals' : true,
                //         'number': Math.round(priceVal),
                //         'decimal': null
                //     });
                // }
            }

            if (Math.floor((Number(priceVal).toFixed(fixed) - Math.floor(priceVal))) >= 1) {
                priceResult.decimal = this.pad(0, fixed);
                priceResult.number += 1;
            }

            if (fn) {
                return fn(priceResult);
            }

            return this._priceToString(priceResult);
        },


        _priceToString: function (priceResult) {
            var symbol = priceResult.currency;
            var symbolOnLeft = false;
            var space = 1;

            if (priceResult.currency_symbol) {
                symbol = priceResult.currency_symbol;
                symbolOnLeft = priceResult.symbol_on_left;
                space = priceResult.space_btw_amount_and_symbol;
            }

            var resultStr = '';

            // no more than 1 space for now. and do not use repeat as it does not work in IE
            var spaceStr = '';
            if (space >= 1) {
                spaceStr = ' ';
            }

            if (priceResult.skip_decimals) {
                if (symbolOnLeft) {
                    resultStr = symbol + spaceStr + priceResult.number;
                } else {
                    resultStr = priceResult.number + spaceStr + symbol;
                }
            } else {
                if (symbolOnLeft) {
                    resultStr = symbol + spaceStr + priceResult.number + priceResult.decimal_separator + priceResult.decimal;
                } else {
                    resultStr = priceResult.number + priceResult.decimal_separator + priceResult.decimal + spaceStr + symbol;
                }
            }
            return resultStr;
        },

        /**
         * Returns client phone data object.
         *
         * @param phone
         * @return {{country_prefix_is_fixed: boolean, client_phone: *}}
         */
        getClientPhoneData: function (phone) {
            var data = {
                country_prefix_is_fixed: false,
                client_phone: phone
            };

            if (Config.getInstance().getOption('country_prefix')) {
                var countryPrefix = Config.getInstance().getOption('country_prefix');
                if (countryPrefix) {
                    countryPrefix = countryPrefix.replace('+', '');
                }
                data.country_prefix = '+' + countryPrefix;

                if (!Config.getInstance().getOption('country_prefix_is_changeable')) {
                    data.country_prefix_is_fixed = true;
                }
            }

            if (!data.client_phone && !data.country_prefix_is_fixed) {
                data.client_phone = data.country_prefix;
            }

            if (data.client_phone && data.country_prefix_is_fixed) {
                var pref = Config.getInstance().getOption('country_prefix').replace('+', '');

                var regexp = new RegExp('(\\+{0,1}(' + this.escapeRegExp(pref) + '){0,1})([0-9\+\-\.]*)');
                var res = regexp.exec(data.client_phone);

                if (!_.isUndefined(res[3])) {
                    data.client_phone = res[3];
                }
                if (_.isUndefined(res[2])) {
                    data.client_phone = phone;
                    data.country_prefix_is_fixed = false;
                    data.country_prefix = '';
                }
            }

            return data;
        },

        /**
         * Returns formatted client phone number, takes into account country prefix settings
         *
         * @param phone
         * @return string
         */
        getClientPhoneValue: function (phone) {
            var config = Config.getInstance();
            var value = phone || '';

            var prefix = config.getOption('country_prefix') ? config.getOption('country_prefix').replace(/^\D+/g, '') : '';

            if (String(value).trim().replace(/^\D+/g, '') === prefix) {
                return '';
            }

            // means that phone value does not contain phone prefix, we need add it
            if (value.indexOf('+') === -1 && config.getOption('country_prefix') && !config.getOption('country_prefix_is_changeable')) {
                if (value.indexOf(prefix) === 0) {
                    value = value.substr(prefix.length);
                }
                value = '+' + prefix + value;
            }

            return value;
        },

        /**
         * Escape string to use it in regexp
         * @param str
         * @return string
         */
        escapeRegExp: function (str) {
            return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        },

        /**
         * Define if mobile browser used
         *
         * @returns {boolean}
         */
        isMobile: function () {
            return (/iphone|ipod|android|ie|blackberry|fennec|nokia|mini|mobile/).test(navigator.userAgent.toLowerCase());
        },

        isIos: function () {
            return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            //or  return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        },

        ifParams: function (condition, params) {
            return condition ? params : {};
        },

        /**
         * Trigger google tag manager event
         *
         * @param event
         * @param data
         */
        triggerGTEvent: function (event, data) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(_.extend({
                'event': event
            }, data));
        },

        pad: function (num, size) {
            var s = num + "";
            while (s.length < size) {
                s = "0" + s;
            }
            return s;
        },

        sendIframePostMessage: function (data) {
            if (!window.parent) return;

            if (window.parent && window.parent !== window) {
                window.parent.postMessage(data, '*');
            }
        },

        /**
         * Minutes to add to a company date/time to display it in the client timezone.
         *
         * Slots (and grouped slots) carry their own value, computed on the server for their own date
         * ('time_diff', DST-aware, see TimelineModel::_clientDiff). The client timezone model's 'time_diff'
         * is the difference for "now" and is only the fallback for data that has no per-date value.
         *
         * @param {Object} data serialized model
         * @param {Backbone.Model} clientTimeZone
         * @param {String} [field='time_diff'] attribute holding the per-date value
         * @return {Number}
         */
        timeDiff: function (data, clientTimeZone, field) {
            field = field || 'time_diff';
            if (data && data[field] !== undefined && data[field] !== null && data[field] !== '') {
                return parseInt(data[field], 10) || 0;
            }
            return clientTimeZone ? (parseInt(clientTimeZone.get('time_diff'), 10) || 0) : 0;
        },

        /**
         * Minutes to add to the booking's selected date/time to display it in the client timezone:
         * the value validate-time returned for exactly this selection ('client_time_offset', DST-aware),
         * otherwise the client timezone's "now" difference.
         *
         * @param {Backbone.Model} bookingModel
         * @param {Backbone.Model} timeValidateModel
         * @param {Backbone.Model} clientTimeZone
         * @return {Number}
         */
        bookingTimeDiff: function (bookingModel, timeValidateModel, clientTimeZone) {
            if (bookingModel && timeValidateModel && timeValidateModel.get('client_time_offset') != null) {
                var dateTime = bookingModel.get('start_date') + ' ' + bookingModel.get('start_time');
                if (timeValidateModel.get('date_time') === dateTime) {
                    return parseInt(timeValidateModel.get('client_time_offset'), 10) || 0;
                }
            }
            return clientTimeZone ? (parseInt(clientTimeZone.get('time_diff'), 10) || 0) : 0;
        },

    };

});
